export default __webpack_public_path__ + "static/media/seminarhaus.306b804b.jpeg";